// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1Sg3_","paramInput":"JobSimulator_paramInput__2VYAC","input":"JobSimulator_input__2axT5"};